import { AUTH_COOKIE_KEY, getCookie, removeCookie, setCookie } from 'utils/cookies'
import { RootState } from 'types'
import workspaceSessionStorage from 'utils/workspaceSessionStorage'

export default function reduce(state: RootState['auth'] = null, { type, payload }: any): RootState['auth'] {
  switch (type) {
    case 'AUTH_SET': {
      const { auth: authWithHeaders } = payload

      setCookie(AUTH_COOKIE_KEY, authWithHeaders)
      workspaceSessionStorage.clear()

      const { headers, ...auth } = authWithHeaders

      return { ...auth }
    }
    case 'AUTH_MERGE': {
      const { auth } = payload
      const newAuth = { ...state, ...auth }

      const cookie = getCookie(AUTH_COOKIE_KEY)
      const headers = cookie?.headers || {}
      setCookie(AUTH_COOKIE_KEY, { ...newAuth, headers })

      return newAuth
    }
    case 'AUTH_UNSET': {
      removeCookie(AUTH_COOKIE_KEY)
      workspaceSessionStorage.clear()
      return null
    }
    default:
      return state
  }
}
